module.exports = __webpack_public_path__ + "static/media/logo_unam.99020ffc.png";